import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle, Sparkles, RotateCcw, Eye, EyeOff } from 'lucide-react';
import { useZihinKilavuzu } from '../../contexts/ZihinKilavuzuContext';

/**
 * Zihin Kılavuzu Floating Trigger Button
 * Always visible help button with hint controls
 */
export default function ZihinKilavuzuTrigger({ className = '' }) {
  const { 
    startOnboarding, 
    hintsDisabled, 
    toggleHints, 
    resetHints,
    dailyCount,
    seenHints
  } = useZihinKilavuzu();
  
  const [isOpen, setIsOpen] = React.useState(false);
  
  return (
    <div className={`fixed bottom-6 right-6 z-[100] ${className}`}>
      {/* Menu */}
      <motion.div
        initial={false}
        animate={{ 
          opacity: isOpen ? 1 : 0,
          scale: isOpen ? 1 : 0.8,
          y: isOpen ? 0 : 20
        }}
        className={`absolute bottom-16 right-0 mb-2 ${isOpen ? '' : 'pointer-events-none'}`}
      >
        <div 
          className="rounded-2xl p-3 min-w-[200px]"
          style={{
            background: 'rgba(12, 12, 24, 0.9)',
            backdropFilter: 'blur(18px)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            boxShadow: '0 0 20px rgba(145, 122, 255, 0.3)'
          }}
        >
          <div className="text-xs text-[#A0A4B3] mb-2 px-2">Zihin Kılavuzu</div>
          
          <button
            onClick={() => { startOnboarding(); setIsOpen(false); }}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-[#E6E6F7] text-sm hover:bg-white/10 transition-colors"
          >
            <Sparkles className="w-4 h-4 text-[#B19CFF]" />
            Rehberi keşfet
          </button>
          
          <button
            onClick={resetHints}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-[#E6E6F7] text-sm hover:bg-white/10 transition-colors"
          >
            <RotateCcw className="w-4 h-4 text-[#22D3EE]" />
            İpuçlarını Sıfırla
          </button>
          
          <button
            onClick={() => toggleHints(!hintsDisabled)}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-[#E6E6F7] text-sm hover:bg-white/10 transition-colors"
          >
            {hintsDisabled ? (
              <>
                <Eye className="w-4 h-4 text-green-400" />
                İpuçlarını Aç
              </>
            ) : (
              <>
                <EyeOff className="w-4 h-4 text-orange-400" />
                İpuçlarını Kapat
              </>
            )}
          </button>
          
          <div className="mt-2 pt-2 border-t border-white/10 px-2">
            <p className="text-[10px] text-[#A0A4B3]">
              Bugün: {dailyCount}/10 ipucu • Görülen: {seenHints.length}
            </p>
          </div>
        </div>
      </motion.div>
      
      {/* Trigger Button */}
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setIsOpen(!isOpen)}
        className="w-12 h-12 rounded-full flex items-center justify-center shadow-lg"
        style={{ 
          background: 'linear-gradient(135deg, #7C3AED, #4A3FFF)',
          boxShadow: '0 4px 20px rgba(124, 58, 237, 0.4)'
        }}
      >
        <motion.div
          animate={{ rotate: isOpen ? 45 : 0 }}
          transition={{ duration: 0.2 }}
        >
          <HelpCircle className="w-5 h-5 text-white" />
        </motion.div>
      </motion.button>
    </div>
  );
}
